import React, { useState, useEffect } from 'react';

const EmailTemplate = () => {
    const [templates, setTemplates] = useState([]);
    const [dbtemplates, setDBtemplates] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('/api/emailtemplate');
                const data = await response.json();
                setTemplates(data);
                setDBtemplates(data);
                setLoading(false);
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);

    const search = (templateName) => {
        if (templateName !== undefined) {
            let data = dbtemplates;
            let result = data;

            if (templateName.trim() !== "") {
                result = data.filter((x) => {
                    return x.title.toLowerCase().indexOf(templateName.toLowerCase()) >= 0;
                });
            }
            setTemplates(result);
        }
    }

    return (
        <div>
            {
                loading ? <p>Loading...</p > :
                    <div className="card" style={{ height: "75vh" }}>
                        <div className="card-header py-3">
                            <h5><i className="fa fa-folder-open-o" aria-hidden="true"></i> Email Templates</h5>
                            <div className="form-group has-search" style={{ float: "right", marginTop: "-35px", marginBottom: "-30px" }}>
                                <span className="fa fa-search form-control-feedback"></span>
                                <input onChange={(e) => { search(e.target.value) }} type="text" className="form-control" placeholder="Search country" />
                            </div>
                            <div style={{ clear: "both" }}></div>
                        </div>
                        <div className="card-body" style={{ width: "100%", maxHeight: "90%!important", overflowY: "auto", paddingRight: "2px", marginLeft: "-5px", marginBottom:"10px" }}>
                            <div>
                                <table style={{ width: "100%" }}>
                                    <tr style={{ backgroundColor: "lightgray", height: "50px" }}>
                                        <td className="emailId">Id</td>
                                        <td className="emailTitle">Title</td>
                                        <td className="emailSubject">SubjectTemplate</td>
                                        <td className="emailSubject">BodyTemplate</td>
                                        <td className="emailBody" style={{ backgroundColor: 'lightgray' }}>Html outlook</td>
                                    </tr>
                                    {templates.map(c =>
                                        <tr key={c.id}>
                                            <td className="emailId">{c.id}</td>
                                            <td className="emailTitle">{c.title}</td>
                                            <td className="emailSubject">{c.subjectTemplate}</td>
                                            <td className="emailSubject">{c.bodyTemplate}</td>
                                            <td className="emailBody"><div className="emailBodyStyle" dangerouslySetInnerHTML={{ __html: c.bodyTemplate }}></div></td>
                                        </tr>
                                    )}
                                </table>
                            </div>
                        </div>
                        <div className="card-footer">
                            Total: {templates.length}
                        </div>
                    </div>
            }
        </div>
    );
}

export default EmailTemplate;